module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Fridge-f7fc5467ba0dcbc006dcd9e07aedb0c4.svg";